// ARCHIVO GENERADO automaticamente por scripts/generate-env.cjs
// NO editar a mano. Los valores provienen del panel de Amplify (fuente de verdad)
// o del fallback src/environments/config/<pais>.<ambiente>.env
export const environment = {
    production: false,
    appVersion: "CVC_WEB.R26.Q2.1.0.NI",
    countryCode: "NI",
    currency: "C$",
    recaptchaSiteKey: "6LcJ_LosAAAAACCfTKMKnE23hEa67bxlLcfl-gUF",
    recaptchaV2SiteKey: "6LdgA7ssAAAAACBbIcEOYgmdsDZNMH8lB8miLXoy",
    recaptchaAction: "login",
    passwordExpirationWarningDays: 5,
    sessionWarningTimeMs: 300000,
    sessionCheckIntervalMs: 60000,
    inactivityTimeMs: 360000,
    inactivityWarningTimeMs: 60000,
    posNumberMinDigits: 8,
    posNumberMaxDigits: 8,
    posPinMinDigits: 4,
    posPinMaxDigits: 6,
    activationsDevEnv: true,
    apiBaseUrl: "https://api.devcvconvergente.claro.com.ni",
    apiAuthUrl: "https://qdnof1wcoi.execute-api.us-east-1.amazonaws.com/Prod",
    apiOnboardingUrl: "https://8kvhslzkik.execute-api.us-east-1.amazonaws.com/Prod",
    apiPasswordUrl: "https://88nglh7bkg.execute-api.us-east-1.amazonaws.com/Prod",
    apiSupportUrl: "https://api.devcvconvergente.claro.com.ni",
    apiTokensUrl: "https://e6m5w7s7q2.execute-api.us-east-1.amazonaws.com/Prod",
    apiVentasUrl: "https://qvij6oyd3e.execute-api.us-east-1.amazonaws.com/dev",
    apiPinUrl: "https://jzvo02b206.execute-api.us-east-1.amazonaws.com/dev",
    apiRecargasUrl: "https://03x894pxda.execute-api.us-east-1.amazonaws.com/dev",
    apiComplianceUrl: "https://api.devcvconvergente.claro.com.ni/compliance",
    apiReportesUrl: "https://n749k39uvf.execute-api.us-east-1.amazonaws.com/dev",
    apiActivacionesUrl: "https://api.devcvconvergente.claro.com.ni/activations",
    apiActivacionesIdentityUrl: "https://api.devcvconvergente.claro.com.ni/activations-identity",
    apiActivationUrl: "https://api.devcvconvergente.claro.com.ni/activation",
    apiProvisioningUrl: "https://api.devcvconvergente.claro.com.ni/provisioning",
    apiBiometricUrl: "https://api.devcvconvergente.claro.com.ni/biometric",
    apiSimUrl: "https://api.devcvconvergente.claro.com.ni/sim",
    apiPortabilidadUrl: "https://api.devcvconvergente.claro.com.ni/portabilidad",
    apiGestionComercialUrl: "https://api.devcvconvergente.claro.com.ni/gestion-comercial",
};
